import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Label from '../../../components/shared/Label';
import { GroupWrapper } from './styles';
import MatchRowFav from '../../../components/MatchRowFav';
import MatchRow from '../../../components/MatchRow';

class GroupTable extends Component {
  isYesterday = (matchDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterdayDate = new Date(today);
    const yesterdayRef = new Date(yesterdayDate.setDate(today.getDate() - 1));
    const currentDay = new Date(matchDate);
    currentDay.setHours(0, 0, 0, 0);
    return yesterdayRef.getTime() === currentDay.getTime();
  };

  isToday = (matchDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const currentDay = new Date(matchDate);
    currentDay.setHours(0, 0, 0, 0);
    return today.getTime() === currentDay.getTime();
  };

  isTomorrow = (matchDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrowDate = new Date(today);
    const tomorrowRef = new Date(tomorrowDate.setDate(today.getDate() + 1));
    const currentDay = new Date(matchDate);
    currentDay.setHours(0, 0, 0, 0);
    return tomorrowRef.getTime() === currentDay.getTime();
  };

  calculateDate = (date) => {
    if (this.isToday(date)) {
      return 'today';
    } else if (this.isTomorrow(date)) {
      return 'tomorrow';
    } else if (this.isYesterday(date)) {
      return 'yesterday';
    }
    return 'other';
  };

  parseLabel = () => {
    const { groupName, preliminariesPlayoffs } = this.props;
    const label = preliminariesPlayoffs ? 'Lega' : 'Gruppo';
    return `${label} ${groupName}`;
  }

  render() {
    const {
      actions, dictionary, isMobile,
      hasHighlights, group,
      betMatch, betType, groupName,
    } = this.props;
    return (
      <GroupWrapper>
        {groupName && groupName !== 'undefined' &&
          <Label
            label={this.parseLabel()}
            isTitleNarrowMedium={isMobile && false}
            size={isMobile ? 0.9 : 1.2}
            alignText="left"
            margin={isMobile ? '20px 0px 20px 10px' : '30px 0px 20px 10px'}
            block
          />
        }
        {group && group.map((currentGame, index) => (
          isMobile ?
            <MatchRowFav
              matchRow={currentGame}
              key={index}
              hasHighlights={hasHighlights}
              actions={actions}
              dictionary={dictionary}
              isMobile={isMobile}
              date={this.calculateDate(currentGame.get('date'))}
              sportId={window.matchcenterPage.sportId}
              competitionId={window.matchcenterPage.competitionId}
              isFav
              betMatch={betMatch}
              betType={betType}
              seasonLink={window.matchcenterPage.seasonLink}
            /> :
            <MatchRow
              matchRow={currentGame}
              key={index}
              hasHighlights={hasHighlights}
              actions={actions}
              dictionary={dictionary}
              isMobile={isMobile}
              date={this.calculateDate(currentGame.get('date'))}
              sportId={window.matchcenterPage.sportId}
              competitionId={window.matchcenterPage.competitionId}
              betMatch={betMatch}
              betType={betType}
              seasonLink={window.matchcenterPage.seasonLink}
            />
        ))
        }
      </GroupWrapper>
    );
  }
}

GroupTable.propTypes = {
  dictionary: PropTypes.any,
  hasHighlights: PropTypes.bool,
  actions: PropTypes.any,
  isMobile: PropTypes.bool,
  group: PropTypes.any,
  groupName: PropTypes.any,
  betMatch: PropTypes.any,
  betType: PropTypes.any,
  preliminariesPlayoffs: PropTypes.any,
};

export default GroupTable;



// WEBPACK FOOTER //
// ./src/containers/CupCalendar/GroupTable/index.js